import { InstituteCheckListDTO } from './../../../models/institute/checkList/instituteCheckListDto';
import { MessageService } from 'primeng/api';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, Validators } from '@angular/forms';
import { Institute } from '../../../models/institute/randomInstituteResponse';
import { ButtonModule } from 'primeng/button';
import { ChipsModule } from 'primeng/chips';
import { InstituteService } from '../../../services/institute/institute.service';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Course } from '../../../models/enums/enums';
import { InstituteCommonDetailsResponse } from '../../../models/institute/instituteCommonDetailsResponse';
import { CourseLevelEnum, CourseLevelEnumDescriptions } from '../../../models/enums/courseLevelEnum';
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule } from "primeng/autocomplete";
import { CompleteProfileService } from '../../../services/account/complete-profile.service';
interface degreePreference {
  name: string,
  key: Course
}

@Component({
  selector: 'app-set-check-list',
  standalone: true,
  imports: [FormsModule, ChipsModule, ButtonModule, DropdownModule, ReactiveFormsModule, CommonModule, AutoCompleteModule],
  templateUrl: './set-check-list.component.html',
  styleUrl: './set-check-list.component.scss'
})
export class SetCheckListComponent implements OnChanges, AfterViewInit {
  constructor(private instituteService: InstituteService,
    private formBuilder: FormBuilder,
    private messageService: MessageService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initilizeForm();
  }

  @ViewChild('courseNameAutoComplete')
  courseNameAutoComplete!: AutoComplete;

  ngAfterViewInit() {
    if (this.courseNameAutoComplete) {
      const inputElement = this.courseNameAutoComplete.el.nativeElement.querySelector('input');
      if (inputElement) {
        inputElement.addEventListener('keydown', (event: { key: string; preventDefault: () => void; }) => {
          if (event.key === 'Enter') {
            // Prevent the default form submission behavior
            event.preventDefault();

            // Programmatically unfocus the input, which will trigger (onBlur)
            inputElement.blur();
          }
        });
      }
    }
  }

  initilizeForm() {
    this.checklistForm = this.formBuilder.group({
      selectedCourseLevel: [this.checkList?.courseLevel, Validators.required],
      selectedCourseName: [this.checkList?.courseName, Validators.required],
      essayPilot: [this.checkList?.essayPilot],
      lors: [this.checkList?.loRs],
      personalDocuments: [this.checkList?.personalDocuments],
      testScores: [this.checkList?.testScores],
      financialAid: [this.checkList?.financialAid],
      applicationForms: [this.checkList?.applicationForms],
    });
  }

  degreePrefs = [
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.BachelorsDegree], key: CourseLevelEnum.BachelorsDegree },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.BachelorsAndMastersDegree], key: CourseLevelEnum.BachelorsAndMastersDegree },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.Certificate], key: CourseLevelEnum.Certificate },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.Diploma], key: CourseLevelEnum.Diploma },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.DoctoralDegree], key: CourseLevelEnum.DoctoralDegree },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.DualDegree], key: CourseLevelEnum.DualDegree },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.FoundationDegree], key: CourseLevelEnum.FoundationDegree },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.MastersDegree], key: CourseLevelEnum.MastersDegree },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.PostgraduateCertificate], key: CourseLevelEnum.PostgraduateCertificate },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.PostgraduateDiploma], key: CourseLevelEnum.PostgraduateDiploma },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.PreSessionalProgram], key: CourseLevelEnum.PreSessionalProgram },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.UndergraduateCertificate], key: CourseLevelEnum.UndergraduateCertificate },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.UndergraduateDiploma], key: CourseLevelEnum.UndergraduateDiploma },
      { name: CourseLevelEnumDescriptions[CourseLevelEnum.Vocational], key: CourseLevelEnum.Vocational }
    ]

  @Input() institute: InstituteCommonDetailsResponse | null | undefined;
  @Output() closeDialog = new EventEmitter();
  @Input() checkList: InstituteCheckListDTO | undefined;
  majors: string[] = [];
  isLoading: boolean = false;
  submitted: boolean = false;
  checklistForm: FormGroup | any;



  SaveInstituteCheckList() {
    this.submitted = true;
    if (this.checklistForm.invalid) {
      return;
    }
    this.isLoading = true;

    const courseName = this.checklistForm.get('selectedCourseName').value;
    const isMajorAlredyInDB = this.majors.includes(courseName);
    if(!isMajorAlredyInDB){
      this.instituteService.addInstituteCourseNames({
      instituteId: this.institute?.id,
      courseLevel: this.checklistForm.get('selectedCourseLevel').value,
      courseName: courseName
      }).subscribe({
          next: () => {
            this.updateChecklistAfterAdd();
          },
          error: (error) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to add new course name: ${error.message}` });
            console.warn(`Error while adding new course name:${error}`);
          }
        });
    }else{
      this.updateChecklistAfterAdd();
    }
  }

  private updateChecklistAfterAdd(){
    var institueCheckList = {
      instituteId: this?.institute?.id ?? '',
      courseLevel: this.checklistForm.get('selectedCourseLevel').value,
      courseName: this.checklistForm.get('selectedCourseName').value,
      essayPilot: this.checklistForm.get('essayPilot').value,
      loRs: this.checklistForm.get('lors').value,
      personalDocuments: this.checklistForm.get('personalDocuments').value,
      testScores: this.checklistForm.get('testScores').value,
      financialAid: this.checklistForm.get('financialAid').value,
      applicationForms: this.checklistForm.get('applicationForms').value,
    }

    this.instituteService.updateCheckList(institueCheckList).subscribe({
      next: (result) => {
        this.isLoading = false;
        this.submitted = false;
        this.messageService.add({ severity: "success", summary: "Success", detail: "CheckList updated successfully!" });
        this.closeDialog.emit();
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: error.name, detail: error.message });
        console.warn(`error while retriving checklist:${error}`);
      }
    });
  }

  onCourseChange($event: DropdownChangeEvent) {
    // this.instituteService.getCheckList({
    //   instituteId: this.institute?.id ?? '',
    //   courseLevel: $event.value,
    //   courseName: this.checklistForm.get('selectedCourseName').value
    // }).subscribe({
    //   next: (result) => {
    //     if (result) {
    //       this.checkList = result;
    //       this.checkList.courseLevel = $event.value;
    //     } else {
    //       this.checkList = { courseLevel: $event.value, courseName: '' };
    //     }
    //     this.initilizeForm();
    //   },
    //   error: (error) => {
    //     console.warn(`error while retriving checklist:${error}`);
    //   }
    // });
  }

  filterIntendedMajors(event: AutoCompleteCompleteEvent){
    if(event.query.length > 3){
      this.instituteService.listInstituteCourseNames({
        courseLevel: this.checklistForm.value.selectedCourseLevel,
        courseName: event.query
      }).subscribe({
        next: (response) => {
          this.majors = response.result;
        }
      })
    }else{
      this.majors = [event.query]
    }
  }

  onCourseNameChange() {
    // Only proceed if a course level is selected, as it's a required parameter.
    if (this.checklistForm.get('selectedCourseLevel').value === null) {
        return;
    }

    this.instituteService.getCheckList({
        instituteId: this.institute?.id ?? '',
        courseLevel: this.checklistForm.get('selectedCourseLevel').value,
        courseName: this.checklistForm.get('selectedCourseName').value
    }).subscribe({
        next: (result) => {
            if (result) {
                this.checkList = result;
                this.checkList.courseLevel = this.checklistForm.get('selectedCourseLevel').value;
            } else {
                this.checkList = { courseLevel: this.checklistForm.get('selectedCourseLevel').value, courseName: this.checklistForm.get('selectedCourseName').value };
            }
            this.initilizeForm();
        },
        error: (error) => {
            console.warn(`error while retrieving checklist: ${error}`);
        }
    });
  }

  // loadCheckList() {
  //   this.instituteService.getCheckList(this.institute?.id ?? '').subscribe({
  //     next: (result) => {
  //       if (result != null) {
  //         this.checkList = result;
  //       }
  //       else {
  //         this.checkList = [];
  //       }
  //     },
  //     error: (error) => {
  //       console.warn(`error while retriving checklist:${error}`);
  //     }
  //   });
  // }
}
